export class DiscountTypeConstants {
    public static discountTypes = {
        9: '5',
        10: '10',
        11: '15',
        12: '0'
    };
}



// WEBPACK FOOTER //
// ./src/app/common/constants/dispute-type.constants.ts